import { UserLoginResponseModel, UserResultModel } from "../../swagger-clients/s365-admin-panel-clients.service";

export const ApplicationTypes = ({
    SET_USER: "SET_USER"
})

export interface ISetUserNameAction {
    type: string;
    user: UserLoginResponseModel;
}